import { QueryClient } from '@tanstack/react-query';

const options = {
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
};

const queryClient = new QueryClient(options);

export default queryClient;
